"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselNavButton", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselNavButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselNavButton = require("./useTeachingPopoverCarouselNavButton");
const _renderTeachingPopoverCarouselNavButton = require("./renderTeachingPopoverCarouselNavButton");
const _useTeachingPopoverCarouselNavButtonStylesstyles = require("./useTeachingPopoverCarouselNavButtonStyles.styles");
const TeachingPopoverCarouselNavButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselNavButton.useTeachingPopoverCarouselNavButton_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselNavButtonStylesstyles.useTeachingPopoverCarouselNavButtonStyles_unstable)(state);
    return (0, _renderTeachingPopoverCarouselNavButton.renderTeachingPopoverCarouselNavButton_unstable)(state);
});
TeachingPopoverCarouselNavButton.displayName = 'TeachingPopoverCarouselNavButton';
